
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.75 3.969s-1.266 1.023-2.438 3c-1.074 1.808-2.109 4.484-2.28 8.031h-8.063c-.172-3.605-1.242-6.258-2.344-8.031-1.2-1.934-2.5-2.907-2.5-2.907L5.937 5.688S6.88 6.345 7.907 8c.933 1.504 1.89 3.793 2.062 7H7v2h2.969c-.172 3.215-1.125 5.547-2.063 7.094C6.875 25.797 5.938 26.5 5.938 26.5l1.218 1.594s1.274-.996 2.469-2.969c1.098-1.809 2.172-4.512 2.344-8.125h8.062c.172 3.55 1.219 6.246 2.282 8.063 1.16 1.984 2.375 3 2.375 3l1.28-1.532s-.929-.777-1.937-2.5c-.914-1.562-1.836-3.867-2-7.031H25v-2h-2.969c.168-3.164 1.11-5.477 2.032-7.031C25.078 6.258 26 5.53 26 5.53z"}})])
          )
        }
      }
    